import { render, staticRenderFns } from "./room-whole-primary-diagram.vue?vue&type=template&id=7b8e310e&scoped=true&"
import script from "./room-whole-primary-diagram.vue?vue&type=script&lang=js&"
export * from "./room-whole-primary-diagram.vue?vue&type=script&lang=js&"
import style0 from "./room-whole-primary-diagram.vue?vue&type=style&index=0&id=7b8e310e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e310e",
  null
  
)

export default component.exports